import { useEffect, useState } from 'react';
import ShopIcon from './../../../assets/images/ShopIcon.png'
import { Link, useLocation } from 'react-router-dom';
import $ from "jquery";
import ShowPasswordClose from "./../../../assets/icons/show-password-icon-close.png";
import ShowPasswordOpen from "./../../../assets/icons/show-password-icon-open.png";
import logo from "./../../../assets/images/logo1.png";
import { ToastContainer, toast } from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PreLoginApi from '../../../components/Api/PreLoginApi';
import FooterContact from '../FooterContact';


var CryptoJS = require("crypto-js");

const NewLogin = () => {


    const { state } = useLocation();

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isFormLoading, setIsFormLoading] = useState(false);
    const [apiData, setApiData] = useState([]);

    let [input, setInput] = useState({
        email: "",
        password: ""
    });

    useEffect(() => {
        if (state !== null) {
            if (state.passwordChangeMessage !== null && state.passwordChangeMessage !== undefined && state.passwordChangeMessage !== "") {
                toast.success(state.passwordChangeMessage.toString());
            }
        }
        window.history.replaceState({}, "");

        if (isLoaded === true) {

            if (error) {
                toast.error(error.messages);
                return;
            }

            let response = JSON.stringify(apiData);
            response = JSON.parse(response);
            if (response["code"] === 200) {
                toast.success(response["data"]["message"]);

                if (response["data"]["token"] !== undefined) {

                    let token = CryptoJS.AES.encrypt(JSON.stringify(response["data"]), process.env.REACT_APP_SECURITY_SALT).toString();
                    window.localStorage.setItem("UserToken", token);



                    // Get Company List
                    PostLoginGetApi("company/lists/switch", "").then((responseJSON) => {

                        let response = JSON.stringify(responseJSON);
                        response = JSON.parse(response);


                        if (response["status"] === 1) {
                            let responseData = JSON.stringify(response["data"]);
                            responseData = JSON.parse(responseData);

                            if (responseData["code"] === 200) {

                                // if company available
                                if (responseData["data"].length > 0) {
                                    document.location.href = "/dashboard/select-company";
                                    return;
                                }


                                // Set 0 as no company
                                window.localStorage.setItem("CompanyId", 0);



                                PostLoginGetApi("company/lists/requested", "", 1).then((responseJSON2) => {
                                    let response2 = JSON.stringify(responseJSON2);
                                    response2 = JSON.parse(response2);

                                    if (response2["status"] === 1) {
                                        let responseData2 = JSON.stringify(response2["data"]);
                                        responseData2 = JSON.parse(responseData2);


                                        if (responseData2["code"] === 200) {
                                            let req_com = responseData2["data"];
                                            if (req_com.length > 0) {

                                                alert('Your application is currently under review. You do not have access at this time. We will notify you of your application status via email.');

                                                document.location.href = "/dashboard/home";
                                                return;
                                            }


                                            document.location.href = "/dashboard/home";
                                            return;

                                        }
                                    }

                                }).catch((err2) => {
                                    console.log(err2);
                                });
                            }
                        }

                    }).catch((err) => {
                        console.log(err);
                    });


                    return;
                }
            }

            toast.error(response["messages"].toString());
        }


        $("#email").trigger("focus");

    }, [apiData, isLoaded]);




    // Get Requested Company lists
    const getRequestedCompany = () => {
        let arr = [];


        return arr;
    }

    const handleInputChange = (e) => {
        setInput({ ...input, [e.name]: e.value });
    }


    useEffect(() => {
        setTimeout(() => {
            $("#email").trigger("click");
            $("#password").trigger("focus");
        }, 1000);
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (input.email?.length === 0) {
            toast.error("Please enter email address !");
            $("#email").focus();
            return;
        }

        if (input.password?.length === 0) {
            toast.error("Please enter password !");
            $("#password").focus();
            return;
        }

        try {
            setIsFormLoading(true);
            let req_body = JSON.stringify({ email: input.email, password: input.password });
            PreLoginApi("panel/login", req_body)
                .then((responseJSON) => {
                    setIsLoaded(true);

                    if (responseJSON.status === 1) {
                        setApiData(responseJSON.data);
                    } else {
                        setError(responseJSON.data);
                    }

                    setIsFormLoading(false);
                })
                .catch((err) => {
                    toast.error(err.toString());
                    setIsFormLoading(false);
                });
        }
        catch (err) {
            toast.error(err);
            console.log(err);
        }
    }


    const showPassword = (id) => {
        $(".show-password-icon").hide();

        if ($("#" + id).attr("type") === "text") {
            $(".show-password-icon").eq(0).show();
            $("#" + id).attr("type", "password");
            return;
        }

        $(".show-password-icon").eq(1).show();
        $("#" + id).attr("type", "text");
        return;
    }

    // Button opacity control on input filled

    $("input[type='text'], input[type='password']").on("input", function () {
        canChangeColor();
    });


    function canChangeColor() {
        var can = true;
        $("input[type='text'], input[type='password']").each(function () {
            if ($(this).val() === '') {
                can = false;
            }
        });

        if (can) {
            $('.btn').css({ opacity: '1' })
            $('.btn').attr('disabled', false);
        } else {
            $('.btn').css({ opacity: '0.6' });
            $('.btn').attr('disabled', true);
        }
    }


    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className='flex justify-center'>
                    <img src={logo} alt="" className='absolute top-12' />
                </div>


                <div
                    className="g-6 flex h-full flex-wrap items-center justify-center lg:justify-center">
                    <div
                        className="shrink-1 mb-12 grow-0 basis-auto md:mb-0 ">
                        <img src={ShopIcon} className="hidden mb-10 lg:block" alt="Shop Icon" />
                    </div>


                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="text-xl mb-4 font-semibold leading-8 text-white md:text-[28px] dark:text-white">
                                        ShareTrip Partner Portal
                                    </p>

                                    <p className='text-white font-medium text-sm mb-6'>Enter your ID and Password to login your account</p>

                                    <form onSubmit={handleSubmit} method="POST">
                                        <div className='mb-3'>
                                            <input type="email" name="email" id="email" value={input.email} autoComplete='off' onChange={(e) => handleInputChange(e.target)} disabled={isFormLoading} className="inputField bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:cursor-not-allowed" placeholder="E-mail" required={true} />
                                        </div>
                                        <div className='mb-5'>
                                            <input type="password" name="password" id="password" value={input.password} autoComplete='off' onChange={(e) => handleInputChange(e.target)} placeholder="Password" disabled={isFormLoading} className="inputField bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:cursor-not-allowed" required={true} />

                                            <img alt="Show Password" className="show-password-icon" src={ShowPasswordOpen} onClick={() => showPassword("password")} style={{ position: "relative", top: "5px", right: "5px" }} />
                                            <img alt="Show Password" style={{ display: "none", position: "relative", top: "7px", right: "7px" }} className="show-password-icon" src={ShowPasswordClose} onClick={() => showPassword("password")}></img>
                                        </div>


                                        <button
                                            type="submit"
                                            disabled={isFormLoading}
                                            className={`btn w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center ${isFormLoading
                                                ? "opacity-60 cursor-not-allowed"
                                                : ""
                                                }`}
                                        >
                                            {isFormLoading ? "Loading..." : "Login"}
                                        </button>



                                        <div className='w-full block pb-6 px-1'>
                                            <Link to="/company-registration-check-email" className="block text-sm font-medium text-white text-left float-left">
                                                Company Registration &rarr;
                                            </Link>
                                            <Link to="/forget-password-step-one" className="block text-sm font-medium text-white text-right float-right">Forgot password?</Link>
                                        </div>

                                    </form>
                                </div>
                            </div>


                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewLogin;